import { createContext, type ReactNode, useContext } from "react";
import { type AppData, useAppData } from "@/data/queries";

const Ctx = createContext<AppData | null>(null);

/** The joined model for every screen. Throws outside the provider (a bug, not a state). */
export function useApp(): AppData {
  const v = useContext(Ctx);
  if (!v) throw new Error("useApp outside AppDataProvider");
  return v;
}

export function AppDataProvider({ children, fallback }: { children: ReactNode; fallback: (msg: string) => ReactNode }) {
  const { data, error } = useAppData();
  if (error) return fallback(`Could not load data: ${(error as { code?: string }).code ?? error.message}`);
  if (!data) return fallback("Loading…");
  return <Ctx.Provider value={data}>{children}</Ctx.Provider>;
}
